"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openValidationNotification = openValidationNotification;
const theme_1 = require("../../components/theme");
const modal_service_1 = require("../../components/modal/modal.service");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const validation_notification_style_1 = require("./validation.notification.style");
(0, theme_1.addStyles)(validation_notification_style_1.Style);
function groupByField(messages) {
    const grouped = new Map();
    for (const msg of messages) {
        const field = msg.field.replace(/^config\//, '');
        if (!grouped.has(field)) {
            grouped.set(field, []);
        }
        grouped.get(field).push(msg);
    }
    return grouped;
}
function renderMessageGroup(field, messages) {
    return (0, mithril_1.m)('div', { className: validation_notification_style_1.CSS.section }, [
        (0, mithril_1.m)('span', { className: validation_notification_style_1.CSS.sectionTitle }, field),
        (0, mithril_1.m)('ul', { className: validation_notification_style_1.CSS.content }, messages.map((msg) => (0, mithril_1.m)('li', { className: validation_notification_style_1.CSS.message }, msg.message || `${msg.field}: ${msg.codes}`))),
    ]);
}
function renderMessages(messages) {
    const grouped = groupByField(messages);
    const children = [];
    grouped.forEach((msgs, field) => {
        children.push(renderMessageGroup(field, msgs));
    });
    return children;
}
function renderCategorySection(headingKey, messages, modifierClass) {
    return (0, mithril_1.m)('div', { className: `${validation_notification_style_1.CSS.categorySection} ${modifierClass}` }, [
        (0, mithril_1.m)('div', { className: validation_notification_style_1.CSS.categoryHeading }, (0, i18n_1.Translate)(headingKey)),
        ...renderMessages(messages),
    ]);
}
function renderValidationContent(config) {
    var _a, _b, _c;
    const sections = [];
    if (((_a = config.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        sections.push(renderCategorySection(i18n_1.T.FORM_IMPORT_VALIDATION_SECTION_ERRORS, config.errors, validation_notification_style_1.CSS.categorySectionError));
    }
    if (((_b = config.warnings) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        sections.push(renderCategorySection(i18n_1.T.FORM_IMPORT_VALIDATION_SECTION_WARNINGS, config.warnings, validation_notification_style_1.CSS.categorySectionWarning));
    }
    if (((_c = config.info) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        sections.push(renderCategorySection(i18n_1.T.FORM_IMPORT_VALIDATION_SECTION_INFO, config.info, validation_notification_style_1.CSS.categorySectionInfo));
    }
    return (0, mithril_1.m)('div', { className: validation_notification_style_1.CSS.container }, sections);
}
function getTitle(config) {
    var _a;
    if (((_a = config.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_VALIDATION_ERROR_TITLE);
    }
    return (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_VALIDATION_WARNING_TITLE);
}
function openValidationNotification(config) {
    var _a;
    const hasErrors = ((_a = config.errors) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const modalContext = Object.assign(Object.assign({ title: getTitle(config), content: renderValidationContent(config), hasCancel: !hasErrors }, (!hasErrors && { okName: i18n_1.T.FORM_IMPORT_VALIDATION_CREATE_FORM })), { className: validation_notification_style_1.CSS.modal });
    return modal_service_1.ModalService.open(modalContext);
}
//# sourceMappingURL=validation.notification.js.map